import { registerComponent } from '@gig/magic-common';
import { MessagePrompterComponent } from './message-prompter.js';

var MessagePrompter = registerComponent(MessagePrompterComponent);

export { MessagePrompter };
